import React from "react"
import { Icon } from "../../shared"
import { labelAktif, jumlahAktif, rentangSalah } from "../../lib/reportFilters"

/* ============================================================
   Bilah saringan ringkas untuk tab yang barisnya BUKAN peserta:
   Kehadiran Sesi (cari, rentang tanggal, ditandai) dan Progres per
   Course (cari). Seperti ReportFilterBar, ia hanya mengubah pilihan;
   server yang menyaring, jadi tabel dan berkas unduhan sama isi.

   Props:
     saringan, ubah(patch), hapusSemua()
     jumlah       { tampil, total, satuan }
     placeholder  teks kotak cari
     urutan       [[urut, arah, labelId, labelEn], …]
     tanggal      tampilkan "dari"/"sampai"
     ditandai     tampilkan "hanya yang ditandai"
   ============================================================ */

const JEDA_KETIK_MS = 300

export default function RingkasFilterBar({
  L, saringan, ubah, hapusSemua, jumlah, placeholder, urutan, tanggal = false, ditandai = false,
}) {
  const [teks, setTeks] = React.useState(saringan.q || "")
  React.useEffect(() => { setTeks(saringan.q || "") }, [saringan.q])
  React.useEffect(() => {
    if (teks === (saringan.q || "")) return undefined
    const t = setTimeout(() => ubah({ q: teks }), JEDA_KETIK_MS)
    return () => clearTimeout(t)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teks])

  const salah = rentangSalah(saringan)

  return (
    <div className="report-filterbar">
      <div className="report-toolbar">
        <div className="search-wrap">
          <Icon name="search" size={14} />
          <input
            className="search-input"
            type="search"
            value={teks}
            onChange={(e) => setTeks(e.target.value)}
            placeholder={placeholder}
            aria-label={placeholder}
            maxLength={100}
          />
        </div>
        {tanggal && (
          <>
            <label className="report-date">
              <span>{L("Dari", "From")}</span>
              <input
                type="date" className="input" value={saringan.dari} max={saringan.sampai || undefined}
                onChange={(e) => ubah({ dari: e.target.value })} aria-invalid={salah}
              />
            </label>
            <label className="report-date">
              <span>{L("Sampai", "Until")}</span>
              <input
                type="date" className="input" value={saringan.sampai} min={saringan.dari || undefined}
                onChange={(e) => ubah({ sampai: e.target.value })} aria-invalid={salah}
              />
            </label>
          </>
        )}
        {ditandai && (
          <label className="report-more-check">
            <input type="checkbox" checked={saringan.ditandai === "1"} onChange={(e) => ubah({ ditandai: e.target.checked ? "1" : "" })} />
            <span>{L("Hanya yang ditandai", "Flagged only")}</span>
          </label>
        )}
        <select
          className="input report-filter-select"
          value={`${saringan.urut}:${saringan.arah}`}
          onChange={(e) => { const [urut, arah] = e.target.value.split(":"); ubah({ urut, arah }) }}
          aria-label={L("Urutkan", "Sort by")}
        >
          {urutan.map(([u, a, id, en]) => (
            <option key={`${u}:${a}`} value={`${u}:${a}`}>{L("Urut: ", "Sort: ")}{L(id, en)}</option>
          ))}
        </select>
        <span className="report-toolbar-count" aria-live="polite">
          {L(`Menampilkan ${jumlah.tampil} dari ${jumlah.total} ${jumlah.satuan[0]}`, `Showing ${jumlah.tampil} of ${jumlah.total} ${jumlah.satuan[1]}`)}
        </span>
      </div>

      {tanggal && (
        <div className="report-date-hint">
          {salah
            ? <span role="alert" style={{ color: "var(--danger)" }}>{L("Tanggal \"dari\" setelah \"sampai\". Perbaiki rentangnya.", "\"From\" is after \"until\". Fix the range.")}</span>
            : L("Tanggal menurut jadwal sesi dalam WIB.", "Dates follow the session schedule in WIB (UTC+7).")}
        </div>
      )}

      {jumlahAktif(saringan) > 0 && (
        <div className="report-chips">
          {labelAktif(saringan, L).map((c) => (
            <button
              key={c.kunci}
              type="button"
              className="report-chip"
              onClick={() => ubah({ [c.kunci]: "" })}
              aria-label={L(`Lepas saringan ${c.label}`, `Remove filter ${c.label}`)}
            >
              {c.label}
              <Icon name="close" size={11} />
            </button>
          ))}
          <button type="button" className="report-chip-clear" onClick={hapusSemua}>
            {L("Hapus semua", "Clear all")}
          </button>
        </div>
      )}
    </div>
  )
}
